/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedShippingInfo_shipment$ref = any;
export type PdpSharedBlurbShipping_shipment$ref = any;
export type PdpSharedBlurbShipping_shipment = {
    readonly " $fragmentRefs": PdpSharedShippingInfo_shipment$ref;
    readonly " $refType": PdpSharedBlurbShipping_shipment$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbShipping_shipment",
  "type": "Shipment",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfo_shipment",
      "args": null
    }
  ]
};
(node as any).hash = 'fd943ebbb247a64b160488f7e7007c7b';
export default node;
